/* eslint-disable max-len */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/react-in-jsx-scope */
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import 'moment-timezone';
import { Icon, IconCloseSched } from '../../../../../base/icons';

const ScheduledMeetingView = props => {
    const { selectedMeeting, setShowMeetingDetail } = props;
    const [ startDate, setStartDate ] = useState('');
    const [ endDate, setEndDate ] = useState('');
    const [ startTime, setStartTime ] = useState('');
    const [ endTime, setEndTime ] = useState('');

    useEffect(() => {
        if (selectedMeeting && selectedMeeting.timeZone) {
            const formatedStartDate = moment(new Date(selectedMeeting.startDate)).tz(selectedMeeting.timeZone).locale('en-US');
            setStartDate(formatedStartDate.format('MM-DD-YYYY'));
            setStartTime(formatedStartDate.format('hh:mm A'));
            const formatedEndDate = moment(new Date(selectedMeeting.endDate)).tz(selectedMeeting.timeZone).locale('en-US');
            setEndDate(formatedEndDate.format('MM-DD-YYYY'));
            setEndTime(formatedEndDate.format('hh:mm A'));
        }
    }, [ selectedMeeting ]);


    return (
        <ModalTransition>
            <div className = 'popup-meeting-view dis-flex jus-center ali-center'>
                <div className='popup-meeting-view-detail-item'>
                    <div className='popup-meeting-view-detail-item-detail'>
                        <div className='popup-meeting-view-detail-item-label'>Name:</div>
                        <div className='popup-meeting-view-detail-item-value'>{selectedMeeting?.meetingName}</div>
                    </div>
                    <div className='popup-meeting-view-detail-item-detail'>
                        <div className='popup-meeting-view-detail-item-label'>Date:</div>
                        <div className='popup-meeting-view-detail-item-value'>{startDate} - {endDate}</div>
                    </div>
                    <div className='popup-meeting-view-detail-item-detail'>
                        <div className='popup-meeting-view-detail-item-label'>Time:</div>
                        <div className='popup-meeting-view-detail-item-value'>{startTime} - {endTime}</div>
                    </div>
{/*                     <div className='popup-meeting-view-detail-item-detail'>
                        <div className='popup-meeting-view-detail-item-label'>Meeting End Time:</div>
                        <div className='popup-meeting-view-detail-item-value'>{endTime}</div>
                    </div> */}
                    <div className='popup-meeting-view-detail-item-detail'>
                        <div className='popup-meeting-view-detail-item-label'>Time Zone:</div>
                        <div className='popup-meeting-view-detail-item-value'>{selectedMeeting.timeZone}</div>
                    </div>
                </div>
                <div className='popup-meeting-view-detail-item-actions' >
                    <Icon
                        onClick = { () => setShowMeetingDetail(false) }
                        size = { 30 }
                        src = { IconCloseSched } />
                    {/* <button onClick = { () => setShowMeetingDetail(false) }>close</button> */}

                </div>
            </div>
        </ModalTransition>

    );

};

ScheduledMeetingView.propTypes = {
    selectedMeeting: {
        meetingName: PropTypes.string,
        endDate: PropTypes.string,
        startDate: PropTypes.string,
        timeZone: PropTypes.string
    },
    setShowMeetingDetail: PropTypes.func
};

export default ScheduledMeetingView;
